export const UPDATE_CONFIG_KEYS = 'updateConfig'
export const GET_PROPS_KEYS = 'getProps'
export const ITEMS_TO_SHOW = 'itemsToShow'
